export const waitForTurnstile = (timeout = 30000, interval = 200) =>
    new Promise((resolve, reject) => {
        const started = Date.now();

        const timer = setInterval(() => {
            if (globalThis.turnstile) {
                clearInterval(timer);
                resolve(globalThis.turnstile);

                return;
            }

            if (Date.now() - started >= timeout) {
                clearInterval(timer);
                reject(new Error("Turnstile did not load in time"));
            }
        }, interval);
    });
